import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { DadosConsultaModel } from "../classes/DadosConsultaModel";
import { Adal4Service } from "adal-angular4";
import { TokenService } from "./token.service";
import { RetornoConsultaModel } from '../classes/RetornoConsultaModel';


@Injectable()
export class ConsultaService {
  
  private headers = new Headers({'Content-Type': 'application/json'});
  options;
  token;

  constructor(private AdalService: Adal4Service, private http: Http, private tokenService: TokenService) { 
    this.token = this.AdalService.userInfo.token;    
    this.headers.append('authorization',`bearer ${this.token}`)
    this.options = new RequestOptions({ headers: this.headers });
    //console.log("Headers: ", this.headers); 
  }

  getReportData(dadosConsulta: DadosConsultaModel) : Promise<any> {
      let url = "/consultardados";
      // if (this.tokenService.handleTokenExpiration()){
      //   return null;
      // }        
      return this.http
      .post(url, JSON.stringify(dadosConsulta), this.options)
      .toPromise()
      .then(report => report.json())
      .catch(this.handleError);
    }

  exportExcel(dadosConsulta: DadosConsultaModel) : Promise<string>{
      let url ="/export";
      // if (this.tokenService.handleTokenExpiration()){
      //   return null;
      // }       
      return this.http
      .post(url, JSON.stringify(dadosConsulta), this.options)
      .toPromise()
      .then(url => url.text())
      .catch(this.handleError);
  }
  
  exportExcelSlim(dadosConsulta: RetornoConsultaModel, reportTitle: string):  Promise<string> {
    let url =`/exportSlim?reportTitle=${reportTitle}`;
    return this.http
      .post(url, JSON.stringify(dadosConsulta), this.options)
      .toPromise()
      .then(url => url.text())
      .catch(this.handleError);
  }

    handleError(error: any): Promise<any> {
      console.error('Ocorreu um erro:', error);
      return Promise.reject(error.message || error);
    //return `Ocorreu um erro ao tentar inserir um relatório: ${error.text}`;
    }


}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/services/consulta.service.ts